<template>
	<v-card>
		<v-card-title class="mt-3">
			<h1 class="ml-2">Ocena przebiegu współpracy</h1>
		</v-card-title>
		<v-container fluid>
			<div v-if="evaluations.length > 0">
				<v-layout mb-3>
					<v-spacer/>
					<v-btn @click="createEvaluation"
						v-if="evaluations[evaluations.length -1].evaluationStatus === 'FINISHED'" class="success"
						style="float: left">Dodaj ocenę
					</v-btn>
					<v-btn @click="exportEvaluations"
						v-if="evaluations.length >=1 && evaluations[0].evaluationStatus === 'FINISHED'" class="success"
						style="float: left">eksportuj
					</v-btn>
				</v-layout>
				<v-layout v-for="(evaluation, evalIdx) in evaluations" v-bind:key="evaluation.id">
					<v-flex>
						<b class="ma-2" style="font-size: 16px">
							Ocena {{ evaluation.evaluationStatus === 'FINISHED' ? "zakończona" : "rozpoczęta" }}
						</b>
						<v-btn v-if="!canEditEvaluation(evaluation)"
							@click="navigateToEvaluation(evaluation)">Podgląd
						</v-btn>
						<v-btn v-if="canEditEvaluation(evaluation)"
							@click="navigateToEvaluation(evaluation)">Edycja
						</v-btn>
						<v-btn v-if="canRemoveBidderEvaluation()" color="error"
							@click="removeBidderEvaluation(evaluation)">Usuń
						</v-btn>

						<div v-if="evaluation.evaluationStatus === 'FINISHED'" class="ma-2"><b>Data: </b> {{ evaluation.latestSendDate }} </div>
						<div v-if="evaluation.evaluationStatus === 'FINISHED'">
							<div v-for="(item, index) in evaluation.points" :key="'points-' + index" class="ma-2">
								<b> {{item.name }}: </b> {{ item.points }}
							</div>
						</div>
						<v-divider class="ma-3" v-if="evaluations.length > 1 && evalIdx < evaluations.length - 1"/>
					</v-flex>
				</v-layout>
			</div>
			<div v-else-if="!evaluationAllowed">
				<v-layout align-center fill-height>
					<h3>Możliwość wykonywania opinii przebiegu współpracy będzie dostępna po podpisaniu umowy</h3>
				</v-layout>
			</div>
			<div v-else>
				<v-layout align-center fill-height>
					<h3>Ocena przebiegu współpracy nie została jeszcze wykonana</h3>
					<v-btn @click="createEvaluation" class="ml-4 success">Oceń</v-btn>
				</v-layout>
			</div>
		</v-container>

		<v-container fluid v-if="arrearsData">
			<v-layout>
				<v-flex xs12 class="ma-1 mt-5">
					<v-card-title>
						<h2>Informacje o zaległych płatnościach</h2>
					</v-card-title>
					<v-container fluid>
						<v-layout>
							<v-flex xs4>
								<v-select
									class="ma-2"
									label="Status płatności"
									:items="arrearsStatusList"
									item-text="name"
									v-model="arrearsData.status"
									item-value="id"
									aria-label="arrears status"
									:disabled="disableOverduePaymentsSection()"
								></v-select>
							</v-flex>
							<v-flex xs4/>
							<v-flex xs4>
								<v-layout align-center justify-center>
									<v-btn color="primary" @click="addArrearDialog = true"
										:disabled="disableOverduePaymentsSection()">Dodaj płatność
									</v-btn>
								</v-layout>
							</v-flex>
						</v-layout>
						<div v-for="(arrear, index) in arrearsData.arrears" :key="'arrear-' + index" class="mb-2">
							<div>
								<div>
									<strong style="font-size: 16px;">Tytuł:</strong>
									<span class="ml-3" style="font-size: 16px;">{{ arrear.title }}</span>
									<v-btn v-if="canEditOrDeleteOverduePaymentsSection()" class="ml-5"
										@click="editArrearTitle(index)" icon ripple>
										<v-icon title="Edytuj">edit</v-icon>
									</v-btn>
									<v-btn v-if="canEditOrDeleteOverduePaymentsSection()"
										@click="deleteArrear(index)" icon ripple>
										<v-icon color="lightred" title="Usuń">delete</v-icon>
									</v-btn>
								</div>
								<div>
									<strong style="font-size: 16px;">Oferenci:</strong>
									<span class="ml-3" style="font-size: 16px;">
										{{ projectBidders.filter(b => arrear.bidderIds.includes(b.id)).map(b => b.name).join(", ") }}
									</span>
								</div>
							</div>
							<ul class="ml-3">
								<li class="mt-2">
									<div>
										<strong style="font-size: 16px;">Zaległość początkowa:</strong>
										<span v-if="!arrear.init || arrear.init <= 0"
											class="ml-3" style="font-size: 16px;">brak</span>
										<span v-else class="ml-3"
											style="font-size: 16px;">{{formatMoney(arrear.init) + " PLN"}}</span>
									</div>
								</li>
								<li class="mt-2">
									<div>
										<strong style="font-size: 16px;">Zaległość teraźniejsza:</strong>
										<span v-if="!arrear.current || arrear.current <= 0"
											class="ml-3" style="font-size: 16px;">brak</span>
										<span v-else class="ml-3"
											style="font-size: 16px;">{{formatMoney(arrear.current) + " PLN"}}</span>
										<span v-if="canEditArrearCurrent(arrear)">
											<v-icon style="font-size: 20px" small class="ml-4"
												@click="editCurrentArrear(index)" title="Edytuj">
												edit
											</v-icon>
										</span>
									</div>
								</li>
							</ul>
						</div>
						<v-layout mt-5><h3>Szczegółowe informacje</h3></v-layout>
						<v-layout>
							<v-flex>
								<v-textarea outline auto-grow v-model="arrearsData.remarks"
									:disabled="disableOverduePaymentsSection()"
									browser-autocomplete="off" aria-label="project arrears remarks"></v-textarea>
							</v-flex>
						</v-layout>
						<v-btn primary @click="saveArrears" :disabled="disableOverduePaymentsSection()">Zapisz</v-btn>
					</v-container>
				</v-flex>
			</v-layout>
		</v-container>

		<v-dialog v-model="addArrearDialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline"> Dodawanie zaległości </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-flex>
							<v-text-field
								browser-autocomplete="off"
								label="Tytuł zaległości"
								aria-label="arrear name"
								for="arrear-name-modal"
								id="arrear-name-modal"
								type="text"
								v-model="editedArrearTitle"
								outline
							></v-text-field>
							<v-autocomplete
								class="ma-2"
								v-model="selectedBiddersIds"
								:items="projectBidders"
								item-text="name"
								item-value="id"
								label="Oferenci"
								aria-label="Arrear bidders"
								for="arrear-bidders"
								id="arrear-bidders"
								clearable
								multiple
							></v-autocomplete>
							<egranty-number-input-field
								label="Kwota"
								v-model="editedArrearValue"
								suffix=" PLN"
							>
							</egranty-number-input-field>
						</v-flex>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="addArrearDialog = false">Anuluj</v-btn>
					<v-btn color="primary" flat @click="addNewArrear" v-if="selectedBiddersIds.length">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="editArrearDialog" max-width="600px">
			<v-card>
				<v-card-title>
					<span class="headline"> Edycja zaległości </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-flex>
							<egranty-number-input-field
								label="Kwota"
								v-model="editedArrearValue"
								suffix=" PLN"
							>
							</egranty-number-input-field>
						</v-flex>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" flat @click="editArrearDialog = false">Anuluj</v-btn>
					<v-btn color="primary" flat @click="saveCurrentArrear">Zapisz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<egranty-input-field-popup
			:is-open.sync="editTitleDialog"
			label="Tytuł"
			title="Zmień tytuł zaległości"
			for="arrear-new-name"
			id="arrear-new-name"
			@save="renameArrear"
		></egranty-input-field-popup>
	</v-card>
</template>

<script>
	import {Files} from "@/utils/Files";
	import {Dates} from "@/utils/Dates";
	import {BidderEvaluation} from "@/api/generated/BidderEvaluation";
	import {Project} from "@/api/generated/Project";
	import {Api} from "@/api";
	import {FinalReport} from "@/api/generated/FinalReport";
	import {Numbers} from "@/utils/Numbers";
	import EgrantyNumberInputField from "../../../genericComponents/EgrantyNumberInputField";
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "ProjectEvaluationView",
		components: {EgrantyInputFieldPopup, EgrantyNumberInputField},
		mixins: [Files, Dates, Numbers],

		data () {
			return {
				finalReportStatus: null,
				arrearsData: null,
				addArrearDialog: false,
				editArrearDialog: false,
				editTitleDialog: false,
				editedArrearIdx: null,
				editedArrearTitle: null,
				editedArrearValue: null,
				projectStatus: null,
				evaluationAllowed: undefined,
				evaluations: [],
        projectBidders: [],
        selectedBiddersIds: [],
				arrearsStatusList: [
					{id: 'NONE', name: 'Brak zaległych płatności'},
					{id: 'NOT_PAID', name: 'Zaległe płatności'},
					{id: 'PAID_OFF', name: 'Zaległe płatności uregulowane'}
				]
			};
		},

		props: {
			project: {
				type: Object,
			},
		},

		watch: {
			editArrearDialog: function (val) {
				if (!val) {
					this.editedArrearIdx = null;
					this.editedArrearValue = null;
				}
			},

			addArrearDialog: function (val) {
				if (!val) {
          this.selectedBiddersIds = this.projectBidders.map(b => b.id);
					this.editedArrearTitle = null;
					this.editedArrearValue = null;
				}
			},

			editTitleDialog: function (val) {
				if (!val) {
					this.editedArrearIdx = null;
					this.editedArrearTitle = null;
				}
			}
		},

		created () {
			this.loadData();
		},

		methods: {
			// górna sekcja
			hasProjectPanelAdminModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelAdminModificationAccess;
			},
			canEditEvaluation(evaluation){
				return (evaluation.evaluationStatus === 'STARTED' || this.hasProjectPanelAdminModificationAccess());
			},
			canRemoveBidderEvaluation(){
				return this.hasProjectPanelAdminModificationAccess();
			},
			// sekcja info o zaległych płatnościach
			hasProjectPanelSupervisorModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelSupervisorModificationAccess;
			},
			canEditOrDeleteOverduePaymentsSection(){
				return (this.finalReportStatus === 'APPROVED' || this.project.status === 'WITHDRAWN');
			},
			disableOverduePaymentsSection(){
				return (this.finalReportStatus !== 'APPROVED' && this.project.status !== 'WITHDRAWN');
			},
			canEditArrearCurrent(arrear){
				return ((this.finalReportStatus === 'APPROVED' || this.project.status === 'WITHDRAWN') && arrear.init > 0);
			},
			exportEvaluations () {
				Api.post(this,
					"/public-contest/project-evaluation-export?projectId=".concat(this.$route.params.projectId),
					{},
					success => {
						let filename = "eksport_ocen.xlsx";
						this.$messagesBus.$emit("success", "Eksport danych z tabeli wykonano do pliku " + filename,
							success);
						Files.methods.downloadBlobResponse(success, filename);
					},
					error => this.$messagesBus.$emit("error", "Eksport nieudany", error),
					{
						responseType: "blob",
					});
			},
			loadData () {
        Project.getBidderAndMutualNames(this, this.$route.params.projectId, successResponse => {
          this.projectBidders = successResponse;
          this.selectedBiddersIds = successResponse.map(b => b.id);
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować oferentów projektu", errorResponse);
        });
				BidderEvaluation.getProject(this, this.$route.params.projectId, successResponse => {
					this.evaluations = successResponse.sort((a, b) => a.id - b.id);
				}, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować danych projektu", errorResponse);
        });
				Project.getStatus(this, this.$route.params.projectId, successResponse => {
						this.projectStatus = successResponse.projectStatus;
						this.evaluationAllowed = successResponse.projectStatus === 'AGREEMENT_SIGNED';
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu konkursu", errorResponse);
					});
				FinalReport.getCurrentState(this, this.$route.params.projectId, successResponse => {
						this.finalReportStatus = successResponse.status;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować statusu sprawozdania", errorResponse);
					});
				Project.getArrears(this, this.$route.params.projectId, successResponse => {
						this.arrearsData = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować zaległości projektu", errorResponse);
					});
			},

			editArrearTitle (idx) {
				this.editedArrearIdx = idx;
				this.editedArrearTitle = this.arrearsData.arrears[this.editedArrearIdx].title;
				this.editTitleDialog = true;
			},

			renameArrear (newTitle) {
				this.arrearsData.arrears[this.editedArrearIdx].title = newTitle;
				this.editTitleDialog = false;
			},

			deleteArrear (idx) {
				this.arrearsData.arrears.splice(idx, 1);
			},

			editCurrentArrear (idx) {
				this.editedArrearIdx = idx;
				this.editedArrearValue = this.arrearsData.arrears[idx].current;
				this.editArrearDialog = true;
			},

			addNewArrear () {
				this.arrearsData.arrears.push({
					id: null,
          bidderIds: this.selectedBiddersIds,
					title: this.editedArrearTitle,
					init: this.editedArrearValue,
					current: this.editedArrearValue,
				});
				this.addArrearDialog = false;
			},

			saveCurrentArrear () {
				let modifiedArrear = this.arrearsData.arrears[this.editedArrearIdx];
				if (modifiedArrear) {
					modifiedArrear.current = this.editedArrearValue;
					this.editArrearDialog = false;
				}
			},

			saveArrears () {
				Project.putArrears(this, this.arrearsData, successResponse => {
					this.$messagesBus.$emit("success", "Informacje o zaległościach zostały pomyślnie zapisane", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać informacji o zaległościach", errorResponse);
				});
			},

			createEvaluation () {
				if (!this.projectStatus || this.projectStatus === "WITHDRAWN") {
					this.$messagesBus.$emit("error", "Nieodpowiedni status konkursu");
					return;
				}
				BidderEvaluation.post(this, this.$route.params.projectId, success => {
					this.$router.push("/app/".concat(this.$route.params.contestId).concat("/" + this.$route.params.projectId + "/").concat("evaluation-form/").concat(success));
				});
			},

			removeBidderEvaluation (evaluation) {
				this.$confirm("Czy na pewno chcesz usunąć ocenę?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie oceny przebiegu współpracy",
					width: 500
				})
					.then(res => {
						if (res) {
							BidderEvaluation.delete(this, evaluation.id, successResponse => {
									this.evaluations = this.evaluations.filter(item => item.id !== evaluation.id);
									this.$messagesBus.$emit("success", "Ocena została pomyślnie usunięta", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć oceny", errorResponse);
								});
						}
					});
			},

			navigateToEvaluation (evaluation) {
				this.$router.push("/app/".concat(this.$route.params.contestId).concat("/" + this.$route.params.projectId + "/").concat("evaluation-form/").concat(evaluation.id));
			},
		},
	};
</script>

<style scoped>

</style>
